module.exports = __webpack_public_path__ + "media/info_animation.b43c6a7d.webm";